import React, { useState, useEffect } from "react";
import { NetworkManager } from "./NetworkManager";

const ImageLoaderNew = ({ path, index, publicUrl = false, onLoad, notfoundImage = null, style }: any) => {
  const [src, setSrc] = useState<any>("");

  useEffect(() => {
    if (!path) return;

    if (publicUrl) {
      fetch(`${NetworkManager.serverPath}api/session/downloadUrl?objectPath=${path}`)
        .then((response) => response.text())
        .then((data) => {
          setSrc(data);
          onLoad(index, data);
        })
        .catch((error) => {
          console.error('Error:', error);
          setSrc('');
        });
    } else {
      const qParam = "objectPath=" + encodeURIComponent(path);
      NetworkManager.sendJsonRequest(
        "api/session/downloadUrl",
        "",
        qParam,
        "GET",
        true,
        (res: any) => {
          setSrc(res);
          onLoad(index, res);
        },
        () => setSrc("")
      );
    }
  }, [path]);


  if (notfoundImage && !src) {
    return <div>No Image</div>;
  }

  return (
    <>
      {src ? <img
        src={src}
        className={`${style ? "" : "image-preview"} relative`}
        style={style}
      /> : <i className="fa-solid fa-image"  style={{color: "gray"}} ></i>  }
    </>
  );
};

export default ImageLoaderNew;